(function() {
  var AccessController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  exports.SppAnalysisController = (function(superClass) {
    extend(SppAnalysisController, superClass);

    function SppAnalysisController(scope, transitions, data, window, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.data = data;
      this.window = window;
      this.http = http;
      this.fetchDeveloperData = bind(this.fetchDeveloperData, this);
      this.clearTree = bind(this.clearTree, this);
      this.setRole = bind(this.setRole, this);
      this.findSurveyById = bind(this.findSurveyById, this);
      this.launchExcelReport = bind(this.launchExcelReport, this);
      this.doTheMath = bind(this.doTheMath, this);
      this.sortSurveys = bind(this.sortSurveys, this);
      this.loadDevSurveyData = bind(this.loadDevSurveyData, this);
      this.loadSurveyData = bind(this.loadSurveyData, this);
      this.getProgramForUser = bind(this.getProgramForUser, this);
      this.fetchRepsForUsers = bind(this.fetchRepsForUsers, this);
      this.fetchProgramsUsers = bind(this.fetchProgramsUsers, this);
      this.enablePrograms = bind(this.enablePrograms, this);
      SppAnalysisController.__super__.constructor.call(this, 'spp_analysis', this.http);
      this.scope.title = 'SPP Analysis';
      this.scope.fullpage = true;
      this.scope.absolute_errors = true;
      this.scope.excelUrl = 'backend/admin/spp-analysis/do-the-math';
      this.scope.companies = [];
      this.scope.programs = [];
      this.scope.dates = [];
      this.scope.companies_array = [];
      this.scope.enableProgram = false;
      this.scope.showSurveys = false;
      this.scope.is_developer = false;
      this.scope.is_account_services = false;
      this.scope.submit = false;
      this.scope.role_needs_set = true;
      this.scope.selected = {};
      this.scope.selected.program = null;
      this.scope.selected.company = null;
      this.scope.selected.user = null;
      this.scope.selected.rep = null;
      this.scope.style = '';
      this.scope.program_options = [];
      this.scope.users = [];
      this.scope.users_reps = [];
      this.scope.reps = [];
      this.scope.surveys = [];
      this.scope.disabled = false;
      this.scope.loading = false;
      this.scope.enablePrograms = this.enablePrograms;
      this.scope.fetchProgramsUsers = this.fetchProgramsUsers;
      this.scope.fetchRepsForUsers = this.fetchRepsForUsers;
      this.scope.getProgramForUser = this.getProgramForUser;
      this.scope.doTheMath = this.doTheMath;
      this.scope.launchExcelReport = this.launchExcelReport;
      this.scope.setRole = this.setRole;
      this.scope.clearTree = this.clearTree;
      this.scope.fetchDeveloperData = this.fetchDeveloperData;
      this.scope.loadDevSurveyData = this.loadDevSurveyData;
    }

    SppAnalysisController.prototype.enablePrograms = function() {
      var company, i, j, len, len1, program, ref, ref1;
      this.scope.program_options = [];
      if (this.scope.selected.company) {
        ref = this.scope.companies;
        for (i = 0, len = ref.length; i < len; i++) {
          company = ref[i];
          if (company.id === this.scope.selected.company) {
            ref1 = company.programs;
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              program = ref1[j];
              this.scope.program_options.push([program.id, program.display_name]);
            }
          }
        }
      }
      return this.scope.program_options.sort(function(a, b) {
        a = a[1].toLowerCase();
        b = b[1].toLowerCase();
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      });
    };

    SppAnalysisController.prototype.fetchProgramsUsers = function(program, company) {
      this.scope.users = [];
      this.scope.loading = true;
      return this.data.fetchProgramsUsers(program, company).then((function(_this) {
        return function(response) {
          var res;
          res = response.data;
          if (res.status.type === 'success') {
            _this.scope.users = res.data.users;
            _this.scope.users_reps = res.data.reps;
            return _this.scope.loading = false;
          }
        };
      })(this));
    };

    SppAnalysisController.prototype.fetchRepsForUsers = function(user) {
      this.scope.reps = this.scope.users_reps[user.username];
      return this.scope.reps.sort();
    };

    SppAnalysisController.prototype.getProgramForUser = function(user) {
      if (this.scope.surveys.length > 0) {
        this.scope.surveys = [];
      }
      if (user != null) {
        if (this.scope.selected.rep) {
          return this.loadSurveyData(user.id, this.scope.selected.rep);
        } else {
          return this.loadSurveyData(user.id, this.scope.reps);
        }
      }
    };

    SppAnalysisController.prototype.loadSurveyData = function(user, rep, fsr_id) {
      if (fsr_id == null) {
        fsr_id = null;
      }
      return this.data.getProgramForUser(user, rep, this.scope.selected.program, fsr_id).then((function(_this) {
        return function(response) {
          var res;
          res = response.data;
          if (res.status.type === 'success') {
            _this.scope.finished_surveys = res.data;
            _this.sortSurveys();
            return angular.element(_this.window).trigger('resize');
          }
        };
      })(this));
    };

    SppAnalysisController.prototype.loadDevSurveyData = function(fsr_id) {
      return this.loadSurveyData(null, null, fsr_id);
    };

    SppAnalysisController.prototype.sortSurveys = function() {
      var i, k, len, ref, survey, v;
      ref = this.scope.finished_surveys;
      for (i = 0, len = ref.length; i < len; i++) {
        survey = ref[i];
        for (k in survey) {
          v = survey[k];
          if (k === 'display_name') {
            this.scope.surveys.push(v);
            break;
          }
        }
      }
      this.scope.surveys.sort(function(a, b) {
        return new Date(b.substr(-19)) - new Date(a.substr(-19));
      });
      if (this.scope.surveys.length === 0) {
        return this.scope.showSurveys = true;
      } else {
        return this.scope.showSurveys = true;
      }
    };

    SppAnalysisController.prototype.doTheMath = function(index) {
      return this.launchExcelReport(index);
    };

    SppAnalysisController.prototype.launchExcelReport = function(id) {
      var url, win;
      url = this.scope.excelUrl + '?' + $.param({
        survey: this.findSurveyById(id),
        program: this.scope.selected.program
      });
      win = this.window.open(url, '_blank');
      return true;
    };

    SppAnalysisController.prototype.findSurveyById = function(id) {
      var i, len, ref, survey;
      ref = this.scope.finished_surveys;
      for (i = 0, len = ref.length; i < len; i++) {
        survey = ref[i];
        if (survey.id === id) {
          return survey;
        }
      }
    };

    SppAnalysisController.prototype.setRole = function(dev) {
      var company, program, user;
      company = this.scope.selected.company;
      program = this.scope.selected.program;
      user = this.scope.selected.user;
      if (dev) {
        this.scope.is_developer = true;
        this.scope.is_account_services = false;
        this.scope.fetchDeveloperData();
        if (program != null) {
          return this.fetchDeveloperData(program);
        }
      } else {
        this.scope.is_account_services = true;
        this.scope.is_developer = false;
        this.loadScopeData(this.data.getCompanies(), 'companies').then((function(_this) {
          return function(result) {
            if (company != null) {
              _this.enablePrograms();
              if (program != null) {
                _this.clearTree('program');
                _this.fetchProgramsUsers(_this.scope.selected.program, _this.scope.selected.company);
                return _this.getProgramForUser(_this.scope.selected.user);
              }
            }
          };
        })(this));
        if ((user != null) && (program != null) && (company != null)) {
          return this.getProgramForUser(user);
        }
      }
    };

    SppAnalysisController.prototype.clearTree = function(level) {
      if (level == null) {
        level = null;
      }
      if (level === 'company') {
        this.scope.selected.program = null;
        this.scope.selected.user = null;
        this.scope.selected.rep = null;
        this.scope.program_options = [];
        this.scope.users = [];
        this.scope.reps = [];
      } else if (level === 'program') {
        this.scope.selected.user = null;
        this.scope.selected.rep = null;
        this.scope.users = [];
        this.scope.reps = [];
      } else if (level === 'user') {
        this.scope.selected.rep = null;
        this.scope.reps = [];
      }
      this.scope.surveys = [];
      return this.scope.showSurveys = false;
    };

    SppAnalysisController.prototype.fetchDeveloperData = function(pp_id) {
      if (pp_id == null) {
        pp_id = null;
      }
      this.scope.loading = true;
      return this.data.fetchDeveloperData(pp_id).then((function(_this) {
        return function(response) {
          var res;
          res = response.data;
          if (res.status.type === 'success') {
            if (res.data.pp) {
              _this.scope.pp_ids = res.data.pp;
            }
            if (res.data.fsr) {
              _this.scope.fsr_ids = res.data.fsr;
            }
            if (res.data.companies_id) {
              _this.scope.selected.company = res.data.companies_id;
            }
          }
          return _this.scope.loading = false;
        };
      })(this));
    };

    return SppAnalysisController;

  })(AccessController);

}).call(this);
